import { graphql } from "@opensea/graphql"
import { getMediaPropsFromMediaFragment } from "@/components/collection/overview/utils"

export const FreeformContentBlockSlideFragment = graphql(
  `
    fragment FreeformContentBlockSlide on DefaultContentBlock {
      title
      description
      externalLink {
        href
        label
      }
      contentMedia: media {
        ...MediaProps
      }
    }
  `,
  [getMediaPropsFromMediaFragment],
)
